/* eslint-disable import/no-anonymous-default-export */
import {
  CREATECATEGORY,
  UPDATECATEGORY,
  DELETECATEGORY,
  FETCHCATEGORYS,
  FETCHCATEGORY,
} from "../constants/actionTypes";

export default (categories = [], action) => {
  switch (action.type) {
    case DELETECATEGORY:
      return categories._id !== action?._id;
    case UPDATECATEGORY:
      return categories?._id === action?.payload._id
        ? action?.payload
        : categories;
    case CREATECATEGORY:
      return [...categories, action.data.data];
    case FETCHCATEGORYS:
      return action.payload;
    case FETCHCATEGORY:
      return action.payload;
    default:
      return categories;
  }
};
